import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'src/app/services/user-service/user.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-signin-send-password-card',
  templateUrl: './signin-send-password-card.component.html',
  styleUrls: ['./signin-send-password-card.component.scss']
})
export class SigninSendPasswordCardComponent implements OnInit, OnDestroy {

  errorMessage: string;
  successMessage: string;
  recoveryPassSubscription: Subscription;
  basicDataForm = new FormGroup({
    mail: new FormControl(null, [Validators.required, Validators.email])
  });

  constructor(private userService: UserService,
              private userStorageService: UserStorageService) { }

  ngOnInit() {
  }

  public sendEmail() {
    this.errorMessage = '';
    this.successMessage = '';
    const validation = this.validateForm();
    if (validation === true) {
      this.recoveryPassSubscription = this.userService.recoveryPass(this.userStorageService.getLang(), this.userStorageService.getUDID(), this.basicDataForm.get('mail').value).subscribe(
        (sended) => {
          if (sended) {
            this.successMessage = 'signin-page.snackbar messages.email sended';
          }
        }
      );
    } else {
      this.errorMessage = validation;
    }
  }

  private validateForm() {
    if (this.basicDataForm.get('mail').errors && this.basicDataForm.get('mail').errors.required) {
      return 'signin-page.snackbar messages.empty email';
    } else if (this.basicDataForm.get('mail').errors && this.basicDataForm.get('mail').errors.email) {
      return 'signin-page.snackbar messages.email format error';
    } else {
      return true;
    }
  }

  public toLowerCase(eRef) {
    eRef.value = eRef.value.toLowerCase();
  }

  ngOnDestroy() {
    if (this.recoveryPassSubscription) { this.recoveryPassSubscription.unsubscribe(); }
  }
}
